const resources = `7 apps de manicura artistica para encontrar todos los estilos
Academic Journals - Journal By Title
AccessScience
ACM Digital Library
Advances in Psychodermatology
Agricultural Statistics
AHFE Open Access
Alhatorah
All About Birds, Cornell Lab of Ornithology
Alzheimer's Association Tools and Resources
American Indian Film Gallery
American Journal of Economics
American Journal of International Law
American Journal of Veterinary Research
American Society of Ichthyologists and Herpetologists
American Welding Society  Standards & Publications
AnatomyZone
AnimalBase
Animals
Annals of Emergency Medicine
Aparatologia Estetica: La Guia Completa
AquaDocs
Art and Architecture Thesaurus
ArXiv
ASCE Library
ASCP Podcasts
Asian-Pacific Journal of Second and Foreign Language Education
Aviation Safety and Security
Awesome Library
Bartleby Collection
BASE - Bielefeld Academic Search Engine
BEARD ALFA Productos de Barberia, Peluqueria, Cuidado
Beauty Launchpad
Beauty Market Estetica
Behindthechair:  Education and Inspiration for Professional Hairstylists
Bible Odyssey
Big Data & Society
Big Data and Cognitive Computing
Biodiversity Heritage Library
BLB Bible Concordances
Blood
Blood Advances
Blood Global Hematology
Blood Vessels, Thrombosis and Hemostasis
BMC Biology
Bright Lights Film Journal
British Actuarial Journal
BSW Biblical Studies
Business Perspectives: Problems and Perspectives in Management
Cahiers du Cinema
Carnegie Museum of Art
Case Reports in Dermatology
CDC
CDC Oral Health
Census Bureau Data
Center for Astrophysics | Harvard & Smithsonian
CEPAL - Publicaciones
Chemical vapour deposition (CVD)
ChemRxiv
Chiropractic & Manual Therapies
Christian Classics Ethereal Library
Circulo de Linguistica Aplicada a la Comunicacion
Clinical Nurse Specialist
ClinicalTrials.gov
CMS
Cochrane Library
Cogent Education
Cognition and Instruction
Communication for Business Success
Communications Medicine
Complementary Therapies in Medicine
Compression moulding
Conductual
Consejos-tendencias en manicure
Cooperative Digital Resources Initiative (CDRI) - Atla Digital Library
CORE
Corpus Thomisticum
Cosmetics
Cosmetology - Hair, Haistyles, Hair Loss and Removal Web Resources
Cosmetology State Board Exam Practice Test Questions & Answers - Quiz & Trivia
Countries - The World Factbook
CourtListener
Crossref
Curriculum and Teaching Methodology
Cursos MOOC - Cursos Masivos Abiertos y en Linea -
Cybersecurity
DASH Repository
Data Science and Management
Data USA
DBLP - Computer science bibliography
Dermatology
Design Science
Developments in the Built Environment
Diccionario RAING
Digital Business
Digital Education Resource Archive (DERA)
Digital Public Library of America
DigiVatLib
Directory of Open Access Books
DOAJ - Directory of Open Access Journals
Dryad
Early Christian Writings: New Testament, Apocrypha, Gnostics, Church Fathers
Earth's Future
ECGpedia
ECONBIZ
Economic Indicators and Releases - MyNBER
Education Sciences
Education Sciences
Educational Technology & Society
EDUCAUSE Library
Electronics
Emergency Care and Medicine
Emergency Medicine International
EMS Prehospital Evidence Based Protocols
Encyclopedia
Energy and AI
English Education:Journal of English Teaching and Research
ERIC - Education Resources Information Center
Esmaltes, Bases, Brillos y Mas
Estetica Magazine
ETHOS | Emerging Threat Open Sharing
EU-LAC Foundation Resources
Europe PMC
European data
European Journal of Educational Research
Exposicion a agentes quimicos de productos cosmeticos. BASEQUIM - Portal INSST - INSST
FAA Technical Library
FDA on Cosmetics
FDA Purplebook
FDA-Approved Drugs
Federal Reserve Economic Data -FRED
Film-Philosophy
Filmsite
Finance and Society
Financial Innovation
FindLaw
Fotor
Frontiers in Artificial Intelligence
Frontiers in Big Data
Frontiers in Blockchain
Frontiers in Built Environment
Frontiers in Child and Adolescent Psychiatry
Frontiers in Communication
Frontiers in Communications and Networks
Frontiers in Developmental Psychology
Frontiers in Disaster and Emergency Medicine
Frontiers in Education
Frontiers in Freshwater Science
Frontiers in Language Sciences
Frontiers in Marine Science
Frontiers in Ocean Sustainability
Frontiers in Organizational Psychology
Frontiers in Pharmacology
Frontiers in Physiology
Frontiers in Rehabilitation Sciences
Frontiers in Social Psychology
Frontiers in Sports and Active Living
Frontiers in Sustainable Tourism
Frontiers in Veterinary Science
Gale OneFile: Nursing and Allied Health
Gale Onefile: Science
GALILEO Open Learning Materials
Generador de Diseño de Uñas
German Law Journal
Getty Library
GitHub - Awesome-public-datasets
Global Challenges
Global Solar Atlas
Glosario de Inteligencia Artificial (IA) para la educacion
Google Patents
Google Scholar
Groomer to Groomer
Guia de bioseguridad para salones de belleza y centros de estetica
G-W Online Textbooks
Hair Colour for Hairstylists: Level 2
Hair Magazine
Hairstyles, Haircuts, Color Ideas, and Trends
HAL - Archive ouverte
Harvard Business Review
Harvard Dataverse
HealthData
HealthIT
Heritage
High Performance Cluster Computing
HKUST-NIE Social Media Lab
Holistic Nursing Practice
HSTalks
Human Factors in Healthcare
Humanities and Social Sciences Communications
HVAC - Cold Climate Heat Pump Sizing
IADB Publications
IDEAS - Economics and Finance Research
IEA - Energy System
IEEE - IEEE Xplore Digital Library
IIFAC-MOOC
ILO Encyclopaedia of Occupational Health and Safety
iNaturalist
Induction/flame hardening
Innerbody
Innovation in Aging
INSPIRE
Institute for Economics and Peace
Institute For the Future of Education
Institute of Physics
IntechOpen - Open Science Open Minds
Intellect Books
International Journal of Air-Conditioning and Refrigeration
International Journal of Behavioral Nutrition and Physical Activity
International Journal of Biological Sciences
International Journal of Concrete Structures and Materials
International Journal of Design
International Journal of First Aid Education
International Journal of Information Management Data Insights
International Journal of Marketing Studies
International Journal of Refrigeration
International Journal of Therapeutic Massage & Bodywork Research Education & Practice
International Journal of Trichology
International Soil and Water Conservation Research
International Trade Center Resources
Internet History Sourcebooks Project: Ancient History
Investigacion y Educacion en Enfermeria
Investigo
iScience
Jewish Historical Studies
Jewish Studies
Jewish Studies, an Internet Journal
Journal Of American College of Emergency Physicians
Journal of Artificial Intelligence Research
Journal of Cosmetic and Laser Therapy
Journal of Cosmetology and Trichology
Journal of Cultural Analytics
Journal of Dental Materials and Techniques
Journal of Economics and Development Studies
Journal of Electrical and Computer Engineering
Journal of Emergency and Critical Care Medicine
Journal of Engineering Education
Journal of Future Foods
Journal of Health Education Teaching
Journal of Health Equity
Journal of Human Sciences and Extension
Journal of Imaging
Journal of Information Technology in Construction
Journal of Infrastructure Intelligence and Resilience
Journal of Machine Learning Research
Journal of Marketing Analytics
Journal of Medical Ethics and History of Medicine
Journal of Medical Radiation Sciences
Journal of Modern Jewish Studies
Journal of Nephropharmacology
Journal of Responsible Innovation
Journal of Social & Health Sciences
Journal of Social Ontology
Journal of the American Veterinary Medical Association
Journal of Thermal Engineering
Journal of Welding and Joining
Journal of Writing Research
Kidney and Blood Pressure Research
Kidney Medicine
Kidney Research and Clinical Practice
Law Archive Papers
LibGuides: Open Access Digital Theological Library: Databases
Library of Congress
Life Sciences, Society and Policy
Limnology and Oceanography Letters
Management Science
Massage Therapy Journal
Material Connexion
Materials and Design
Mayo Clinic RSS
Media History Digital Library
Medical Career Academy
Medicina Estetica
Medicina Naturista
Medline
Medscape Reference: Drugs, Diseases & Medical Procedures
Mendeley Data
Merck Manual Professional Edition
Merck Veterinary Manual
MERLOT
Merriam-Webster: America's Most Trusted Dictionary
MetaArXiv Preprints
Mike Holt Enterprises Free Resources
MIT Libraries
Modern Salon eBooks
Modern Salon Webinars
MOOC - Principales cursos sobre Art - Aprende sobre Art en linea.
MOOC - Principales cursos sobre Mooc - Aprende sobre Mooc en linea.
MOOC Udemy: cursos en linea para habilidades, carreras profesionales e IA
MOOCs, Opcion Gratuita y de Alta Calidad | Uniandes
My Open Bible - Online Study Bible
Nail Pro - Revista especializada en decoracion de uñas - Nailistas
Nail Salon Techniques, Nail Art, Business Tips
NASA POWER: Prediction Of Worldwide Energy Resources
NASA Technical Reports Server
Nation Master: Global Industry Market Sizing
National Fire Protection Association Codes and Standards
National Gallery of Art
National Institute of Standards and Technology
National Renewable Energy Laboratory
NaturaLista Colombia
NIST Standard Reference Materials
NPJ Urban Sustainability
NYPL Digital Collections
OATD  Open Access Theses and Dissertations
Observatorio de Inteligencia Artificial en Educacion Superior
Occupational Outlook Handbook
Ocean Acidification International Coordination Centre (OA-ICC)
Ocean and Coastal Research
Oceans
OECD Publications
OER Commons
Old Testament Essays
Open Access Biomedical Image
Open Access Button
Open Access in Law
Open Access in Psychology
Open Access Oceanography
Open Access to Ocean Data
Open Data Policy Repository
Open Knowledge Repository
Open Library of Humanities
Open Source in Environmental Sustainability
OpenAIRE Service Catalogue
OpenAlex technical documentation
OpenICPSR: Behavioral health and social science research data
OpenStax
OTC Monograph Resources - FDA
OTL - Office of Technology Licensing
OWID
Pan American Health Organization Publications
Paul and Patristics
Pentecostal and Charismatic Research Archive
PerfectCorp
Perseus Digital Library
Pets
Pharmacy
Pharmacy Practice
Philosophy, Ethics, and Humanities in Medicine
Phlebotomy tutorial for medical education
PLOS
PQAI: Patent Quality Artificial Intelligence
Prehospital Emergency Care
Proceedings of the Design Society
Project Euclid
Project Gutenberg
PsyArXiv Preprints
PsychArchives
PubChem
PubMed
Repositorio Banco de la Republica
Research in Ministry
Resilient Cities and Structures
Restorative Dentistry and Endodontics
Revista Cuidarte
Revista de Cosmetologia y Tricologia
Revista de la Asociacion Colombiana de Dermatologia y Cirugia Dermatologica
Revista Espanola de Nutricion Humana y Dietetica
Revista Española de Educacion Comparada
Revista Española de Podologia
Revista Innovacion Estetica
Revista Signos: Estudios de Linguistica
Revista Vida Estética y Spa
Revistas Cientificas Complutenses
Revistas Nueva Estetica
Royal Society of Chemistry
Safety & Fire Technology
Safety and Health at Work: International Labour Organization
SafetyLit: Injury Research and Prevention Literature Update
SciAlert Journals
Science Advances
Science Progress
Scientific Reports
Semantic Scholar
Semantics of Ancient Hebrew Database
Simulador de Unas IA: Prueba Virtual de Esmalte & Formas | Facetune
Sistema de Informacion Cientifica Redalyc, Red de Revistas Cientificas
Skincare Advice
Sociometrics
Spanish Journal of Marketing
Springer
SSRN
Stanford Encyclopedia of Philosophy
Stanford Large Network Dataset Collection
Statistics on safety and health at work
Strong's Exhaustive Concordance
Studies in English Language and Education
Sustainable Materials and Technologies
Techopedia: Educando a Profesionales Tecnologicos
Tecnologias de la informacin Online Courses
Telebelleza
Telematics and Informatics
Teoria de la Educacion
The Association of Religion Data Archives
The Database of Religious History
The Innovation
The Lancet Digital Health
The Law Dictionary
The National Electrical Code (NEC)
The National Teaching Repository
The Ocean Agency - Ocean Image Bank
The Open Medical Devices Journal
The Open Nursing Journal
The Open University's Carbon Calculator
The Ultrasound Journal
The University of Chicago Press: Open Access at Chicago
Theological Commons
Trip Medical Database
U.S. Bureau of Economic Analysis (BEA)
U.S. Census Bureau QuickFacts: United States
U.S. Department of Labor : Training and Reference Materials Library
U.S. Energy Information Administration (EIA)
UNESCO Biblioteca Digital
UNESCO Tesauro
United Nations Interregional Crime and Justice Research Institute
United Nations Publications
US Department and Human Service
US National Library of Medicine
Veterinary Sciences
Virtual Economics
Visual Computing for Industry, Biomedicine, and Art
Welding in the World
WHO guideline on HIV service delivery
Widescreen Journal
World Bank Open Data
World Bank Publications
World Development Indicators
World Health Organization Publications
World Ocean Database
World Travel & Tourism Council
Zenodo`;

export const quoteResources = [...new Set(resources.split('\n'))].sort((a, b) =>
	a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true }),
);
